import { Card, CardDescription, CardHeader, CardTitle, StatusBadge } from '@app/ui';
import { FadeIn, StaggerContainer, StaggerItem } from '@app/ui/motion';

const ROADMAP_ITEMS = [
  {
    title: '1099-Ready Tax Exports',
    description:
      'Download a tax-season-ready summary of every received payment, formatted for your CPA or TurboTax.',
  },
  {
    title: 'FERPA-Ready Audit Trails',
    description:
      'Immutable, exportable activity logs for every brand deal and institution inventory record — built for compliance reviews.',
  },
  {
    title: 'Automated Overdue Outreach',
    description:
      'When a payment goes overdue, NilBoard sends polite, on-brand follow-ups to the brand on your behalf.',
  },
];

export function RoadmapSection() {
  return (
    <section className="py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <FadeIn>
          <h3 className="text-2xl font-bold text-center mb-2">On the Horizon</h3>
        </FadeIn>
        <FadeIn delay={0.1}>
          <p className="text-muted-foreground text-center mb-8">
            What we're actively building next, so you know where NilBoard is headed.
          </p>
        </FadeIn>
        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ROADMAP_ITEMS.map((item) => (
            <StaggerItem key={item.title}>
              <Card className="h-full">
                <CardHeader>
                  <div className="mb-2">
                    <StatusBadge status="COMING_SOON" />
                  </div>
                  <CardTitle>{item.title}</CardTitle>
                  <CardDescription>{item.description}</CardDescription>
                </CardHeader>
              </Card>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}
